import {IChat, IChatAttachment, IChatMember} from "@retail-data-factory/rdf-angular-types-api";
import {emptyParty, emptyUser, IParty, IUser} from "@retail-data-factory/rdf-angular-types-api";
export const mockUnicreditUser:IUser ={...emptyUser, id: '112844', userName: 'unicredit_demo'};
export const mockUnicreditStore1User:IUser = {...emptyUser, id: '7', userName: 'unicredit_store1' };
export const mockUnicreditStore2User:IUser = {...emptyUser, id: '8', userName: 'unicredit_store2'};
export const mockUnicreditStore3User:IUser = {...emptyUser, id: '9', userName: 'unicredit_store3'};

export const mockChatMemberUnicredit:IChatMember = {
  party: { ...emptyParty, id:'15116', name: 'ЮникредитБанк'  },
  user: {...mockUnicreditUser}
};
export const mockChatMemberUnicreditStore1:IChatMember = {
  party: { ...emptyParty, id:'2463', name: 'Щука ООО'  },
  user: {...mockUnicreditStore1User}
};
export const mockChatMemberUnicreditStore2:IChatMember = {
  party: { ...emptyParty, id:'6224', name: 'СИГУР ООО'  },
  user: {...mockUnicreditStore2User}
};
export const mockChatMemberUnicreditStore3:IChatMember = {
  party: { ...emptyParty, id:'7414', name: 'Кандилян Г.Р. ИП'  },
  user: {...mockUnicreditStore3User}
};


export const mockChatList:Array<IChat> = [
  {
    chatId: '1',
    messages: [
      {messageId: '1', messageDate: null, authorId: '112844', authorName: 'unicredit_demo', authorImg: './img/app_icons/camera.png', messageText: 'Привет', attachments: []},
      {messageId: '3', messageDate: null, authorId: '112844', authorName: 'unicredit_demo', authorImg: './img/app_icons/camera.png', messageText: 'Еще привет', attachments: []},
      {messageId: '4', messageDate: null, authorId: '2463', authorName: 'unicredit_store1', authorImg: './img/app_icons/camera.png', messageText: 'Еще пока', attachments: []},
      {messageId: '5', messageDate: null, authorId: '112844', authorName: 'unicredit_demo', authorImg: './img/app_icons/camera.png', messageText: 'Все равно привет', attachments: []}
    ],
    members: [{...mockChatMemberUnicredit}, {...mockChatMemberUnicreditStore1}],
    creator: {...mockUnicreditUser},
    chatName: 'ИмяЧата1',
    chatImg: './img/app_icons/camera.png'
  },
  {
    chatId: '2',
    messages: [
      {messageId: '1', messageDate: null, authorId: '112844', authorName: 'unicredit_demo', authorImg: './img/app_icons/camera.png', messageText: 'Тест', attachments: []},
      {messageId: '2', messageDate: null, authorId: '6224', authorName: 'unicredit_store2', authorImg: './img/app_icons/camera.png', messageText: 'Тест', attachments: []},
      {messageId: '3', messageDate: null, authorId: '112844', authorName: 'unicredit_demo', authorImg: './img/app_icons/camera.png', messageText: 'Еще тест', attachments: []},
      {messageId: '4', messageDate: null, authorId: '6224', authorName: 'unicredit_store2', authorImg: './img/app_icons/camera.png', messageText: 'Еще раз пройден', attachments: []},
      {messageId: '5', messageDate: null, authorId: '112844', authorName: 'unicredit_demo', authorImg: './img/app_icons/camera.png', messageText: 'Все равно тест', attachments: []}
    ],
    members: [{...mockChatMemberUnicredit}, {...mockChatMemberUnicreditStore2}],
    creator: {...mockUnicreditUser},
    chatName: 'ИмяЧата2',
    chatImg: './img/app_icons/camera.png'
  }



];
